import React from 'react';
import { useAuth } from './AuthContext';
import AuthenticationScreen from '../components/auth/AuthenticationScreen';

function AuthGuard({ children, fallback = null }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#1a202c',
        color: 'white',
        fontSize: '18px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '20px', fontSize: '48px' }}>🔐</div>
          <div>Checking authentication...</div>
        </div>
      </div>
    );
  }

  // If not authenticated, show fallback or default auth screen
  if (!isAuthenticated) {
    if (fallback) {
      return fallback;
    }

    /*
     * Default fallback — the login splash.
     *
     * AuthGuard sits INSIDE the router's route table, so it has no access to the
     * `betaKeyValidation` / `betaKeyRequest` navigation handlers that AppRouter
     * passes on the real `realLogin` route. Previously this rendered
     * `<AuthenticationScreen />` bare, which left Sign Up and "request a beta key"
     * as controls that did nothing at all.
     *
     * Rather than leave dead buttons, hand off to the top of the app. A full
     * document return to `/` restarts the router at its login route with the
     * handlers correctly wired — the same recovery `handleApiAuthError()` performs
     * when the backend rejects a session. It is a deliberate reload, not a
     * client-side transition, because the point is to rebuild auth state from
     * scratch.
     */
    const returnToSignIn = () => {
      console.log('AuthGuard: unauthenticated route reached - returning to the sign-in entry');
      window.location.href = '/';
    };

    return (
      <AuthenticationScreen
        onBetaKeyFlow={returnToSignIn}
        onRequestBetaKey={returnToSignIn}
      />
    );
  }

  // User is authenticated, render children
  return children;
}

export default AuthGuard;